(function($, exports) {
	exports.init = function() {
		var $filter = $('.c-people-filter');
		var $people = $('.js-person');

		$filter.on('click', function(e) {
			var type = $(this).data('type');
			$filter.removeClass('is-active');
			$(this).addClass('is-active');

			$people.hide();

			if (type === 'all') {
				$('.js-person').show();
			}

			if (type === 'lorentz') {
				$('.js-lorentz').show();
			}

			if (type === 'jong') {
				$('.js-jong').show();
			}
		});
	};
})(jQuery, (this.PEOPLEFILTERS = {}));
